import { escapeHtml } from '../ui.js'
import { portalSideNavHtml, wirePortalSideLogout } from '../portalSideNav.js'
import { clientLogout, clientOpenTickets } from '../api.js'
import {
  clearClientSession,
  getClientSession,
  isClientLoggedIn,
} from '../clientAuth.js'
import {
  persistPortalActiveInstallationId,
  resolvePortalActiveInstallationId,
} from '../portalInstallContext.js'

export function renderClientTickets() {
  return `
    <div class="dash-app">
      <aside class="dash-side">
        <p class="dash-side-label">Portal</p>
        <nav class="dash-side-nav" aria-label="Portal cliente">
          ${portalSideNavHtml({ activePath: '/mi-instalacion/tickets', nav: { pending_tickets: 1 } })}
        </nav>
        <button type="button" id="dash-logout" class="portal-btn dash-side-logout">Salir</button>
      </aside>
      <div class="dash-main">
        <div class="dash-hero">
          <div>
            <p class="portal-eyebrow">Portal cliente</p>
            <h1>Tickets abiertos</h1>
            <p class="portal-muted">Incidencias de soporte en curso.</p>
          </div>
          <div class="dash-hero-actions">
            <a href="/mi-instalacion/nueva-incidencia" data-link class="portal-btn portal-btn-primary portal-btn-rounded">Nueva incidencia</a>
          </div>
        </div>
        <div id="tickets-list" class="portal-card"></div>
        <p id="tickets-msg" class="portal-muted portal-form-msg" role="status"></p>
      </div>
    </div>`
}

const STATUS_LABELS = {
  open: 'Abierto',
  in_progress: 'En curso',
  waiting: 'En espera',
}

export function bindClientTickets(root, { navigate }) {
  if (!isClientLoggedIn()) {
    navigate('/cliente', { replace: true })
    return
  }

  const session = getClientSession()
  let installationId = resolvePortalActiveInstallationId(session)
  const msg = root.querySelector('#tickets-msg')
  const list = root.querySelector('#tickets-list')

  wirePortalSideLogout(root, {
    navigate,
    onLogout: async () => {
      try {
        await clientLogout()
      } catch (_) {}
      clearClientSession()
      navigate('/', { replace: true })
    },
  })

  async function load() {
    msg.textContent = 'Cargando…'
    list.innerHTML = ''
    try {
      const data = await clientOpenTickets(installationId)
      if (data.installation_id) {
        installationId = data.installation_id
        persistPortalActiveInstallationId(installationId)
      }
      const tickets = data.tickets || []
      if (tickets.length === 0) {
        list.innerHTML =
          '<p class="portal-muted" style="padding:1rem;">No hay tickets abiertos. <a href="/mi-instalacion/nueva-incidencia" data-link>Crear incidencia</a></p>'
        msg.textContent = ''
        return
      }
      list.innerHTML = `<ul class="dash-signals">${tickets
        .map(
          (t) => `
        <li class="dash-signal dash-signal--warn">
          <span>${escapeHtml(t.ticket_number)} · ${escapeHtml(STATUS_LABELS[t.status] || t.status)}</span>
          <strong>${escapeHtml(t.subject || '')}</strong>
        </li>`
        )
        .join('')}</ul>`
      msg.textContent = ''
    } catch (e) {
      msg.textContent = e.message || 'Error al cargar tickets.'
    }
  }

  load()
}
